export default __webpack_public_path__ + "static/media/sdg-15-load.d2af5f7e.png";